<template>
  <BookingTable></BookingTable>
</template>
<script>
import BookingTable from '@/components/resources/booking/BookingTable.vue'
export default {
  components: { BookingTable }
}
</script>
